import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HyperlinkDirective } from './hyperlink.directive';

@NgModule({
  declarations: [HyperlinkDirective],
  exports: [HyperlinkDirective],
  imports: [CommonModule],
})
export class HyperlinkModule {}
